import Vue from 'vue'
import Router from 'vue-router'
import axios from 'axios';
import { requestError, env } from '@/shared/utils';

// Containers
const DefaultContainer = () => import ('@/containers/DefaultContainer')

const Corporations = () => import ('@/views/corporations/Corporations')
const Corporation = () => import ('@/views/corporations/Corporation')
const CorporationView = () => import ('@/views/corporations/CorporationView')
const CorporationGroups = () => import ('@/views/corporations/CorporationGroups')
const CorporationGroup = () => import ('@/views/corporations/CorporationGroup')
const ApplicationApiKey = () => import ('@/views/corporations/ApplicationApiKey')

const Monitor = () => import ('@/views/monitoring/Monitor')

const Charts = () => import ('@/views/Charts')

const Dashboard = () => import ('@/views/Dashboard')

// Views - Pages
const Page404 = () => import ('@/views/pages/Page404')
const Page500 = () => import ('@/views/pages/Page500')
const Login = () => import ('@/views/pages/Login')
const Register = () => import ('@/views/pages/Register')

// Views - Icons
const Flags = () => import('@/views/icons/Flags')
const FontAwesome = () => import('@/views/icons/FontAwesome')
const SimpleLineIcons = () => import('@/views/icons/SimpleLineIcons')
const CoreUIIcons = () => import('@/views/icons/CoreUIIcons')

// Users
const Users = () => import ('@/views/users/Users')
const User = () => import ('@/views/users/User')
const UserBatch = () => import ('@/views/users/UserBatch')
const UserSignerImport = () => import ('@/views/users/UserSignerImport')
const UserGroups = () => import ('@/views/users/UserGroups')
const UserGroup = () => import ('@/views/users/UserGroup')

// UsersRetail
const UsersRetail = () => import ('@/views/users_retail/UsersRetail')
const UserRetail = () => import ('@/views/users_retail/UserRetail')

// Reports
const ReportActivations = () => import ('@/views/reports/Activations')
const ReportUsersOperation = () => import ('@/views/reports/UsersOperation')
const ReportWithoutOperation = () => import ('@/views/reports/WithoutOperation')
const ReportUsers = () => import ('@/views/reports/Users')
const ReportSynthetic = () => import ('@/views/reports/DashboardSynthetic')
const ReportRetailUserIndicators = () => import ('@/views/reports/RetailUserIndicators')
const PurchaseTransactions = () => import ('@/views/reports/PurchaseTransactions')

const LockFactor = () => import ('@/views/lock_factor/LockFactor')
const LogsUtility = () => import ('@/views/logs_utility/LogsUtility')
const LogUtility = () => import ('@/views/logs_utility/LogUtility')
const UserDeepDetail = () => import ('@/views/user_deep_detail/UserDeepDetail')
const OtpDevice = () => import ('@/views/otp_device/OtpDevice')
const MailSupressionList = () => import ('@/views/mail_supression_list/MailSupressionList')
const LogsSMS = () => import ('@/views/logs_sms/LogsSms')

// Perfis de usuário
const UsersRole = () => import ('@/views/user_role/UsersRole')
const UserRole = () => import ('@/views/user_role/UserRole')

Vue.use(Router)

function requireAuth(to, from, next) {
    axios
        .get(`${env.urlBillingApi}/auth`)
        .then(function(response) {
            next();
        })
        .catch(function(error) {
            requestError(error);
            next({
                path: '/pages/login',
                redirect: '/pages/login'
            });
        });
}

export default new Router({
    mode: 'hash', // https://router.vuejs.org/api/#mode
    linkActiveClass: 'open active',
    scrollBehavior: () => ({ y: 0 }),
    routes: [{
            path: '/',
            redirect: '/dashboard',
            name: 'Home',
            component: DefaultContainer,
            children: [{
                    path: 'clean',
                    name: ''
                },{
                    path: 'dashboard',
                    name: 'Dashboard',
                    beforeEnter: requireAuth,
                    component: Dashboard
                },
                {
                    path: 'corporations',
                    meta: { label: 'Corporações' },
                    beforeEnter: requireAuth,
                    component: {
                        render(c) { return c('router-view') }
                    },
                    children: [{
                            path: '',
                            component: Corporations,
                        },
                        {
                            path: 'edit/:id',
                            meta: { label: 'Corporação' },
                            name: 'Corporação Edit',
                            component: Corporation,
                        },
                        {
                            path: 'monitor/:id',
                            meta: { label: 'Monitor' },
                            name: 'Monitor',
                            component: Monitor,
                            props: true
                        },
                        {
                            path: 'api-key/:id',
                            meta: { label: 'Chave de API' },
                            name: 'ApplicationApiKey',
                            component: ApplicationApiKey,
                            props: true
                        },
                        {
                            path: 'new',
                            meta: { label: 'Corporação' },
                            name: 'Corporação New',
                            component: Corporation
                        },
                        {
                            path: 'view/:id',
                            meta: { label: 'Corporação' },
                            name: 'Corporação View',
                            component: CorporationView,
                        }
                    ]
                },
                {
                    path: 'users',
                    meta: { label: 'Usuários' },
                    beforeEnter: requireAuth,
                    component: {
                        render(c) { return c('router-view') }
                    },
                    children: [{
                            path: '',
                            component: Users,
                        },
                        {
                            path: 'edit/:id',
                            meta: { label: 'Usuário' },
                            name: 'Usuário Edit',
                            component: User,
                        },
                        {
                            path: 'new',
                            meta: { label: 'Usuário' },
                            name: 'Usuário New',
                            component: User,
                        },
                        {
                            path: 'batch',
                            meta: { label: 'Usuário' },
                            name: 'Usuário Lote',
                            component: UserBatch,
                        },
                        {
                            path: 'signer-import',
                            meta: { label: 'Usuário' },
                            name: 'Usuários Assinantes PJ',
                            component: UserSignerImport,
                        }
                    ]
                },
                {
                    path: 'user-groups',
                    meta: { label: 'Grupos de Usuários' },
                    beforeEnter: requireAuth,
                    component: {
                        render(c) { return c('router-view') }
                    },
                    children: [{
                            path: '',
                            component: UserGroups,
                        },
                        {
                            path: 'edit/:id',
                            meta: { label: 'Grupo de Usuários' },
                            name: 'Grupo Edit',
                            component: UserGroup,
                        },
                        {
                            path: 'new',
                            meta: { label: 'Grupo de Usuários' },
                            name: 'Grupo New',
                            component: UserGroup,
                        }
                    ]
                },
                {
                    path: 'corporation-groups',
                    meta: { label: 'Grupos de Corporações' },
                    beforeEnter: requireAuth,
                    component: {
                        render(c) { return c('router-view') }
                    },
                    children: [{
                            path: '',
                            component: CorporationGroups,
                        },
                        {
                            path: 'edit/:id',
                            meta: { label: 'Grupo de Corporações' },
                            name: 'Grupo Edit',
                            component: CorporationGroup,
                        },
                        {
                            path: 'new',
                            meta: { label: 'Grupo de Corporações' },
                            name: 'Grupo New',
                            component: CorporationGroup,
                        }
                    ]
                },
                {
                    path: 'users-retail',
                    meta: { label: 'Usuários Varejo' },
                    beforeEnter: requireAuth,
                    component: {
                        render(c) { return c('router-view') }
                    },
                    children: [{
                            path: '',
                            component: UsersRetail,
                        },
                        {
                            path: 'edit/:id',
                            meta: { label: 'Usuário Varejo' },
                            name: 'Usuário Varejo Edit',
                            component: UserRetail,
                        },
                        {
                            path: 'new',
                            meta: { label: 'Usuário Varejo' },
                            name: 'Usuário Varejo New',
                            component: UserRetail,
                        }
                    ]
                },
                {
                    path: 'reports',
                    meta: { label: 'Relatórios' },
                    beforeEnter: requireAuth,
                    component: {
                        render(c) { return c('router-view') }
                    },
                    children: [{
                            path: 'users-operation',
                            meta: { label: 'Operações de usuários' },
                            name: 'Operações de usuários',
                            component: ReportUsersOperation,
                        },{
                            path: 'whithout-operation',
                            meta: { label: 'Usuários sem operação' },
                            name: 'Usuários sem operação',
                            component: ReportWithoutOperation,
                        },
                        {
                            path: 'activations',
                            meta: { label: 'Ativações e renovações' },
                            name: 'Ativações e renovações',
                            component: ReportActivations,
                        },
                        {
                            path: 'retail-user-indicators',
                            meta: { label: 'Indicadores Usuários Varejo' },
                            name: 'Indicadores Usuários Varejo',
                            component: ReportRetailUserIndicators,
                        },
                        {
                            path: 'users',
                            meta: { label: 'Usuários' },
                            name: 'Usuários',
                            component: ReportUsers,
                        },
                        {
                            path: 'synthetic',
                            meta: { label: 'Sintético' },
                            name: 'Sintético',
                            component: ReportSynthetic,
                        },
                        {
                            path: 'purchase-transactions',
                            meta: { label: 'Transações de Compras BirdID' },
                            name: 'Transações de Compras BirdID',
                            component: PurchaseTransactions,
                        },
                    ]
                },
                {
                    path: 'admin',
                    meta: { label: 'Administração' },
                    beforeEnter: requireAuth,
                    component: {
                        render(c) { return c('router-view') }
                    },
                    children: [
                        {
                            path: 'lock-factor',
                            meta: { label: 'Fator de Bloqueio' },
                            // name: 'Fator de Bloqueio',
                            component: LockFactor,
                        },
                        {
                            path: 'logs-utility',
                            meta: { label: 'Logs do utilitário' },
                            name: 'Logs do utilitário',
                            component: LogsUtility
                        },
                        {
                            path: 'log-utility',
                            meta: { label: 'Log do utilitário' },
                            name: 'Log do utilitário',
                            component: LogUtility,
                            props: true
                        },
                        {
                            path: 'user-deep-detail',
                            meta: { label: 'Detalhes de Usuário' },
                            component: UserDeepDetail,
                        },
                        {
                            path: 'users-role',
                            meta: { label: 'Perfis de Usuário' },
                            // name: 'Fator de Bloqueio',
                            component: {
                                render(c) { return c('router-view') }
                            },
                            children: [{
                                    path: '',
                                    component: UsersRole,
                                },
                                {
                                    path: 'edit/:provider/:id',
                                    meta: { label: 'Perfil de Usuário' },
                                    name: 'Perfil de Usuário Edit',
                                    component: UserRole,
                                },
                                {
                                    path: 'new/:provider',
                                    meta: { label: 'Perfil de Usuário' },
                                    name: 'Perfil de Usuário New',
                                    component: UserRole,
                                }
                            ]
                        },
                        {
                            path: 'otp-device',
                            meta: { label: 'Cartões OTP' },
                            name: 'Cartões OTP',
                            component: OtpDevice
                        },
                        {
                            path: 'mail-supression-list',
                            meta: { label: 'Lista de Supressão' },
                            name: 'Lista de Supressão',
                            component: MailSupressionList
                        },
                        {
                            path: 'logs-sms',
                            meta: { label: 'Log de Envio de SMS' },
                            name: 'Log de Envio de SMS',
                            component: LogsSMS
                        },
                    ]
                },
                {
                    path: 'charts',
                    meta: { label: 'charts' },
                    component: Charts
                },
                {
                    path: 'icons',
                    redirect: '/icons/font-awesome',
                    name: 'Icons',
                    component: {
                        render (c) { return c('router-view') }
                    },
                    children: [
                        {
                        path: 'coreui-icons',
                        name: 'CoreUI Icons',
                        component: CoreUIIcons
                        },
                        {
                        path: 'flags',
                        name: 'Flags',
                        component: Flags
                        },
                        {
                        path: 'font-awesome',
                        name: 'Font Awesome',
                        component: FontAwesome
                        },
                        {
                        path: 'simple-line-icons',
                        name: 'Simple Line Icons',
                        component: SimpleLineIcons
                        }
                    ]
                },
            ]
        },
        {
            path: '/pages',
            redirect: '/pages/404',
            name: 'Pages',
            component: {
                render(c) { return c('router-view') }
            },
            children: [{
                    path: '404',
                    name: 'Page404',
                    component: Page404
                },
                {
                    path: '500',
                    name: 'Page500',
                    component: Page500
                },
                {
                    path: 'login',
                    name: 'Login',
                    component: Login
                },
                {
                    path: 'register',
                    name: 'Register',
                    component: Register
                }
            ]
        }
    ]
})